import React from "react";


function MTSFooter() {
    return (
        <div className="footer-basic">
            <footer>
                <ul className="list-inline">
                    <li className="list-inline-item"><a href="#">Home</a></li>
                    <li className="list-inline-item"><a href="#">Services</a></li>
                    <li className="list-inline-item"><a href="#">About</a></li>
                    <li className="list-inline-item"><a href="#">Terms</a></li>
                    <li className="list-inline-item"><a href="#">Privacy Policy</a></li>
                </ul>
                <p className="copyright">MTS Group � 2019</p>
            </footer>
        </div>
        );
}

export default MTSFooter;